import {
  type PriceValue,
  type PricingModelType
} from '@elfsight/configurator-contracts';
import { type DiscountValue, type OldPriceValue } from '../../types';

interface GetDiscountProps {
  discount: DiscountValue;
  newPrice: PriceValue;
  oldPrice: OldPriceValue;
  locale?: string;
}

export const modelsWithoutDiscount: PricingModelType[] = [
  'range',
  'free',
  'custom'
];

export const getDiscount = ({
  discount,
  locale = navigator.language,
  newPrice,
  oldPrice
}: GetDiscountProps) => {
  const { customLabel, discountType, enabled } = discount;

  if (!enabled) {
    return;
  }

  const { price: oldPriceValue } = oldPrice;
  const { currency, price: newPriceValue, pricingModel } = newPrice;

  if (
    discountType === 'custom' ||
    modelsWithoutDiscount.includes(pricingModel)
  ) {
    return customLabel;
  }

  const difference = Math.max(Math.round(oldPriceValue - newPriceValue), 0);
  const percentage = Math.round(
    (difference / Math.max(oldPriceValue, 1)) * 100
  );

  const numberFormatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    currencyDisplay: 'narrowSymbol',
    maximumFractionDigits: 0
  });
  const formattedDifference = numberFormatter.format(difference);
  const percentageLabel = `${percentage}%`;

  if (discountType === 'amount') {
    return formattedDifference;
  }

  if (discountType === 'percentage') {
    return percentageLabel;
  }

  return `${formattedDifference} (${percentageLabel})`;
};
